import { Line } from './Line';
export class Rectangle {
    /** insert point in an anti-clockwise order */
    constructor(p1, p2, p3, p4) {
        this.p1 = p1;
        this.p2 = p2;
        this.p3 = p3;
        this.p4 = p4;
    }
    isInside(pos) {
        const squareLines = [
            new Line(this.p1, this.p2),
            new Line(this.p2, this.p3),
            new Line(this.p3, this.p4),
            new Line(this.p4, this.p1)
        ];
        let isInside = true;
        let j = 0;
        while (j < 4 && isInside) {
            if (!squareLines[j].isLeft(pos)) {
                isInside = false;
            }
            j++;
        }
        return isInside;
    }
    move(vector) {
        this.p1.applyVector(vector);
        this.p2.applyVector(vector);
        this.p3.applyVector(vector);
        this.p4.applyVector(vector);
        return this;
    }
    fromRelativeToAbsolute(canvas) {
        return new Rectangle(
            this.p1.fromRelativeToAbsolute(canvas),
            this.p2.fromRelativeToAbsolute(canvas),
            this.p3.fromRelativeToAbsolute(canvas),
            this.p4.fromRelativeToAbsolute(canvas)
        );
    }
}
